(function ($) {
    var isTouchDevice = ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
    document.addEventListener('DOMContentLoaded', () => {
        let desktopNav = document.getElementById('nav');
        let headerButtons = document.querySelectorAll('.opener');

        function desktopNavInit(e) {
            e.preventDefault();
            desktopNav.removeEventListener('mouseover', desktopNavInit);
            lazySizes.rAF(function () {
                initDropDown();
                e.target.dispatchEvent(e);
            });
        }
        function buttonsInit(e) {
            try {
                e.preventDefault();
            } catch (e) {
            }
            let that = this;
            headerButtons.forEach((button) => {
                button.removeEventListener('click', buttonsInit)
                button.removeEventListener('touchstart', buttonsInit)
            });
            lazySizes.rAF(function () {
                initOpenClose();
                let openclose;

                let el = that;

                do {
                    openclose = $(el).data('OpenClose');
                } while (!openclose && (el = el.parentNode) !== null);

                if (openclose) {
                    openclose.showSlide();
                }
            });
        }

        if (!isTouchDevice && desktopNav) {
            desktopNav.addEventListener('mouseover', desktopNavInit);
        }

        if (isTouchDevice) {
            initSlideMenu();
            initDropDown();
        }
        if (headerButtons) {
            headerButtons.forEach((button) => {
                button.addEventListener('click', buttonsInit)
                button.addEventListener('touchstart', buttonsInit)
            });
        }
    });
})(jQuery);
